module.exports = __webpack_public_path__ + "img/jcb.238fa585.png";